const Frais=()=>{
return(
    <div className="card-twy mt-16">
        <img src="/images/lock-02.svg" alt="icon lock" />
        <p className="body bold500 grey500 mt-16 mb-0">Frais de service Twyny</p>
        <p className="legend grey66 mt-8 mb-0">
        Pour tout achat effectué sur Twyny, 
        nous appliquons des frais couvrant le bon fonctionnement de notre plateforme et
         notre <a className="primary legend bold500 no-decoration pointer" href='/frais'>Protection acheteurs</a>. Cette protection 
         acheteurs comprend notre <a className="primary  legend bold500 no-decoration pointer"  href='/frais'>Politique de remboursement</a> .
        </p>
    </div>
)
}
export default Frais